import React from 'react';

function Invoice1() {
  return (
    <>
      <section className="invoice1-container">
        <h1 className="inv-H1">Manage Invoices</h1>
        <a className="All-1">All</a>
        <a className="pending-1">Pending</a>
        <a className="completed-1">Completed</a>
        <input type="text" name="search2" placeholder="Search" id="search2" className="search2" required />
        <h2 className="inv-H2">This Week</h2>
        <input type="text" name="INV1" placeholder="" id="INV1" className="INV1" required />
        <input type="text" name="INV2" placeholder="" id="INV2" className="INV2" required />
        <input type="text" name="INV3" placeholder="" id="INV3" className="INV3" required />
        <input type="text" name="INV4" placeholder="" id="INV4" className="INV4" required />
        <a className="back-home2" href="#">Back To Home</a>



      </section>
    </>
  );
}

export default Invoice1;
